import React from "react";
import "./Pages.css";

const RefundPolicy: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Cancellation, Refund and Return Policy</h1>
      <p>
        The Destination Dreams Travel sells travel services. As these are
        time-sensitive, intangible services, a physical "return" does not apply.
        Cancellations and refunds are handled as set out below and are always
        subject to the rules of the relevant airline, hotel or service provider.
      </p>

      <h2>Cancellations</h2>
      <ul>
        <li>
          To cancel or amend a booking, contact us as early as possible with your
          booking reference.
        </li>
        <li>
          Cancellation and change charges are determined by the airline, hotel or
          supplier's fare/rate rules and may be up to 100% of the booking value for
          non-refundable or restricted fares.
        </li>
        <li>
          A Destination Dreams Travel service fee may also apply to process a
          cancellation or amendment.
        </li>
      </ul>

      <h2>Refunds</h2>
      <ul>
        <li>
          Where a booking is eligible for a refund, the refundable amount (after any
          supplier penalties and service fees) is returned to the
          <strong> original payment method/card</strong> used for the purchase.
        </li>
        <li>
          Refunds are processed once the supplier confirms the cancellation. After we
          initiate the refund, it typically reflects on your card/account within
          <strong> 7–14 business days</strong>, depending on your bank's processing
          time.
        </li>
        <li>
          Non-refundable bookings, promotional fares, and certain government taxes or
          third-party fees may not be recoverable.
        </li>
      </ul>

      <h2>How to request</h2>
      <p>Send your cancellation/refund request with your booking reference to:</p>
      <ul>
        <li>Phone: +968 95987986</li>
        <li>Email: team@dreamstriphub.com</li>
        <li>Location: Amirat, Muscat, Oman</li>
      </ul>
      <p>
        All payments are processed in Omani Rial (OMR) via the Bank Muscat secure
        payment gateway.
      </p>
    </div>
  );
};

export default RefundPolicy;
